module.exports = __webpack_public_path__ + "img/surprise.16189e68.svg";